import React from 'react';
import { TrashIcon, Cross2Icon, ExclamationTriangleIcon } from '@radix-ui/react-icons';

const BulkDeleteModal = ({ count, onClose, onConfirm, loading }) => {
    return (
        <div className="fixed inset-0 z-[70] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4" onClick={onClose}>
            {/* GRADIENT BORDER WRAPPER */}
            <div className="relative w-full max-w-md rounded-xl overflow-hidden p-[1px]">
                {/* TRAVELLING LIGHT (THE ENGINE) */}
                <div className="absolute top-[-50%] left-[-50%] h-[200%] w-[200%] animate-[spin_4s_linear_infinite] bg-[linear-gradient(90deg,transparent_45%,#ef4444_50%,transparent_55%)]" />
                {/* INNER CONTENT (BLACK CARD) */}
                <div
                    className="bg-zinc-950 rounded-xl w-full p-6 relative z-10"
                    onClick={(e) => e.stopPropagation()}
                >
                    {/* CLOSE BUTTON */}
                    <button
                        type="button"
                        className="absolute top-4 right-4 text-zinc-500 hover:text-white transition-colors p-1 rounded-lg hover:bg-white/10 z-10"
                        onClick={onClose}
                        disabled={loading}
                    >
                        <Cross2Icon className="h-5 w-5" />
                    </button>

                    {/* HEADER */}
                    <div className="text-center mb-6">
                        <div className="bg-red-500/10 text-red-500 h-20 w-20 rounded-full flex items-center justify-center mb-4 mx-auto">
                            <TrashIcon className="h-10 w-10" />
                        </div>
                        <h2 className="text-2xl font-bold text-white mb-2">
                            Delete {count} Topic{count !== 1 ? 's' : ''}?
                        </h2>
                    </div>

                    {/* WARNING MESSAGE */}
                    <div className="flex items-start gap-3 p-4 bg-red-500/10 border border-red-500/30 rounded-lg mb-6">
                        <ExclamationTriangleIcon className="h-5 w-5 text-red-400 flex-shrink-0 mt-0.5" />
                        <div className="flex-1">
                            <p className="text-sm text-red-200 font-medium leading-relaxed">
                                Are you sure? This action cannot be undone.
                            </p>
                        </div>
                    </div>

                    {/* FOOTER BUTTONS */}
                    <div className="flex gap-3">
                        <button
                            type="button"
                            className="flex-1 px-4 py-3 text-sm font-medium text-zinc-300 hover:text-white hover:bg-white/10 rounded-lg transition-colors"
                            onClick={onClose}
                            disabled={loading}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className={`flex-1 px-4 py-3 text-sm font-medium rounded-lg transition-all flex items-center justify-center gap-2 ${loading
                                    ? 'bg-zinc-800 text-zinc-500 cursor-not-allowed'
                                    : 'bg-red-600 hover:bg-red-700 text-white shadow-lg shadow-red-500/20'
                                }`}
                            onClick={onConfirm}
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                                    Deleting...
                                </>
                            ) : (
                                <>
                                    <TrashIcon className="h-4 w-4" />
                                    Delete
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BulkDeleteModal;
